import { render } from "./Escalation.vue?vue&type=template&id=64b8b0bc"
import script from "./Escalation.vue?vue&type=script&lang=js"
export * from "./Escalation.vue?vue&type=script&lang=js"

import exportComponent from "/private/var/www/html/digicheck-laravel-vue-app/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__